// extracted by css-extract-rspack-plugin
export default {"root":"lNw9RC","star":"ZPfxcA"};